import React from "react";
import { Typography } from "@mui/material";
import Button from "../inputs/Button";
import DialogTemplate from "../../layout/DialogTemplate";

interface ConfirmDialogProps {
  open: boolean;
  title: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  onConfirm: () => void;
  onCancel: () => void;
}

/**
 * Generisches Bestätigungs-Popup (Ja/Nein) auf Basis von DialogTemplate.
 */
const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  open,
  title,
  message,
  confirmLabel = "Bestätigen",
  cancelLabel = "Abbrechen",
  onConfirm,
  onCancel,
}) => (
  <DialogTemplate
    open={open}
    onClose={onCancel}
    title={title}
    maxWidth="xs"
    actions={
      <>
        <Button variant="secondary" onClick={onCancel}>
          {cancelLabel}
        </Button>
        <Button variant="primary" onClick={onConfirm}>
          {confirmLabel}
        </Button>
      </>
    }
  >
    <Typography>{message}</Typography>
  </DialogTemplate>
);

export default ConfirmDialog;
